import React from 'react';
export function MobileBottomBar() {
  return <div className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-atrium-ivory border-t border-atrium-stone shadow-[0_-4px_20px_rgba(0,0,0,0.05)]" data-id="element-51">
      <div className="flex items-center justify-between h-16" data-id="element-52">
        <a href="tel:+61863108888" className="flex-1 flex items-center justify-center h-full text-xs font-bold tracking-wider uppercase text-atrium-ink border-r border-atrium-stone hover:bg-atrium-stone/20 transition-colors" data-id="element-53">
          Call
        </a>
        <a href="#enquire" className="flex-1 flex items-center justify-center h-full text-xs font-bold tracking-wider uppercase text-atrium-ink border-r border-atrium-stone hover:bg-atrium-stone/20 transition-colors" data-id="element-54">
          Enquire
        </a>
        <a href="#latitude" className="flex-1 flex items-center justify-center h-full text-xs font-bold tracking-wider uppercase text-atrium-ink hover:bg-atrium-stone/20 transition-colors" data-id="element-55">
          Display Home
        </a>
      </div>
    </div>;
}